import { EnvConfig } from "@pages/video-script-generator";

const preFillText = {
  LinkedIn: "Check out Sendspark's new AI tool for creating personalized video scripts for your %23sales outreach!",
  Twitter: "Check out Sendspark's new AI tool for creating personalized video scripts for your %23sales outreach!",
  Facebook: "Check out Sendspark's new AI tool for creating personalized video scripts for your sales outreach!",
  Email: "Hey%2c you need to check out Sendspark's new AI tool for creating personalized video scripts for your sales outreach!"
}

const openUrl = (url: string, target = '') => {
  window.open(url, target);
};

export const shareLinkOnTwitter = (env: EnvConfig) => {
  openUrl(
    `https://twitter.com/intent/tweet?text=${preFillText.Twitter} ${env.defaultOrigin}/video-script-generator`,
    '_blank'
  );
};

export const shareLinkOnLinkedIn = (env: EnvConfig) => {
  openUrl(
    `https://www.linkedin.com/sharing/share-offsite/?url=${env.defaultOrigin}/video-script-generator&summary=${preFillText.LinkedIn}`,
    '_blank'
  );
};

export const shareLinkOnMail = (env: EnvConfig) => {
  openUrl(
    `mailto:?subject=AI tool for video prospecting&body=${preFillText.Email} ${env.defaultOrigin}/video-script-generator`,
    '_blank'
  );
};

export const shareLinkOnFacebook = (env: EnvConfig) => {
  openUrl(
    `https://www.facebook.com/sharer/sharer.php?u=${env.defaultOrigin}/video-script-generator&quote=${preFillText.Facebook}`,
    '_blank'
  );
};

export const redirectToSendspark = (toSignup = false, env: EnvConfig) => {
  if (toSignup) {
    openUrl(
      `${env.defaultOrigin}/signup?utm_source=free-tool&utm_medium=video-script-generator&utm_campaign=video-script-generator&utm_content=button`,
      '_blank'
    );
  } else {
    openUrl(
      'https://sendspark.com?utm_source=free-tool&utm_medium=video-script-generator&utm_campaign=video-script-generator&utm_content=button',
      '_blank'
    );
  }
};